// import React from 'react';
import React from 'react';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { Icon } from '@benzinga/core-ui';
import { formatTime, parseDateTime } from '@benzinga/date-utils';
import styled from '@benzinga/themetron';

export interface UpcomingBroadcastCardProps {
  date: string | Date;
  id: string;
  subtitle: string;
  title: string;
}

export const UpcomingBroadcastCard = ({ date, id, subtitle, title }: UpcomingBroadcastCardProps) => {
  const truncate = (text: string) => {
    return text.length > 70 ? text.slice(0, 69) + '…' : text;
  };

  const formatDate = (date: Date | string) => {
    const parsedDate = parseDateTime(date);
    const month = parsedDate.toLocaleString('en-us', { month: 'short' });
    const day = parsedDate.getDate();
    return `${month} ${day}`;
  };

  const handleEnableNotifications = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return (
    <Container
      className="upcoming-broadcast-card"
      href={`https://www.youtube.com/watch?v=${id}`}
      rel="noopener noreferrer"
      target="_blank"
    >
      <div className="card-info">
        <h2 className="broadcast-title">{truncate(title)}</h2>
        <div className="subtitle-date-container">
          <div className="date">
            {formatTime(new Date(date))} - {formatDate(new Date(date))}
          </div>
          <div className="broadcast-subtitle">{subtitle}</div>
        </div>
      </div>
      <div className="bell-icon-wrapper" onClick={handleEnableNotifications}>
        <Icon className="text-gray-400 text-sm" icon={faBell} />
      </div>
    </Container>
  );
};

const Container = styled.a`
  &.upcoming-broadcast-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 5rem;
    padding: 0.75rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    .card-info {
      display: flex;
      flex-direction: column;
      width: 18rem;
    }
    .broadcast-title {
      color: ${({ theme }) => theme.colorPalette.gray800};
      font-size: ${({ theme }) => theme.fontSize.base};
      font-weight: ${({ theme }) => theme.fontWeight.bold};
    }
    .subtitle-date-container {
      display: flex;
      font-size: ${({ theme }) => theme.fontSize.sm};

      .date {
        color: ${({ theme }) => theme.colorPalette.blue500};
        font-weight: ${({ theme }) => theme.fontWeight.bold};
        margin-right: 0.75rem;
      }
    }
    .broadcast-subtitle {
      color: ${({ theme }) => theme.colorPalette.gray500};
    }
    .bell-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: #ffffff;
      border: 1px solid ${({ theme }) => theme.colors.border};
      border-radius: ${({ theme }) => theme.borderRadius.full};
      height: 2.5rem;
      width: 2.5rem;
      bottom: 1rem;
    }
  }
`;
